import { useEffect } from "react";

// Sets document.title for the lifetime of the calling component — the React
// replacement for Next's per-page `metadata` / `generateMetadata`.
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
